import { atom } from "jotai";

import { WelcomeStep } from "../../../types";
import {
  VerificationModalStepStateAtom,
  VerificationModalTrackEventAtom,
} from "../../stores";

export const ProceedToWelcomeStepAtom = atom(
  null,
  (
    get,
    set,
    { clubSlug, emailOrPhone }: { clubSlug: string; emailOrPhone?: string }
  ) => {
    const track = get(VerificationModalTrackEventAtom);
    const nextStep: WelcomeStep = {
      step: "Welcome",
      backStep: "ClubSelection",
      clubSlug,
      emailOrPhone,
    };
    set(VerificationModalStepStateAtom, nextStep);
    track?.("AuthModal.WelcomeStep", nextStep);
  }
);
